import { useMutation } from '@hooks/reactQuery';

import { enableMiddlewareSMO } from '@api/middlewareSMO';

import { MIDDLEWARE_SMO_ENABLE } from '@constants/queryKeys';

import useInvalidateMiddlewareSMO from './useInvalidateMiddlewareSMO';

interface IUseMutateMiddlewareSMOEnableReturned {
	enableMiddlewareSMO: (id: string) => void;
	isLoadingEnableMiddlewareSMO: boolean;
}

const useMutateMiddlewareSMOEnable = (handleCloseModal: () => void): IUseMutateMiddlewareSMOEnableReturned => {
	const invalidateMiddlewareSMO = useInvalidateMiddlewareSMO();

	const {
		isLoading,
		mutate,
	} = useMutation<string>({
		mutationKey: [MIDDLEWARE_SMO_ENABLE],
		mutationFn: enableMiddlewareSMO,
		onSuccess: () => {
			handleCloseModal();

			return invalidateMiddlewareSMO();
		},
	});

	return {
		enableMiddlewareSMO: mutate,
		isLoadingEnableMiddlewareSMO: isLoading,
	};
};

export default useMutateMiddlewareSMOEnable;
